// Fragment "gateway console" — Payment Gateway v1, GatewayConsole.jsx + the
// gateway/components/* it renders (PayoutApproveDialog, PayoutRejectDialog,
// TrialBalancePanel, StepUpConfirmDialog — all bound to useT("superadmin")). "nav.gateway"
// sits alongside the rest of SuperAdminLayout.jsx's nav.* keys, same pattern
// planCapabilities.js uses for "nav.planFeatures".
export default {
  fr: {
    "nav.gateway": "Passerelle de paiement",

    "gw.console.title": "Passerelle de paiement",
    "gw.console.subtitle": "Reversements, paiements, litiges et grand livre du système de paiement — les actions qui déplacent de l'argent exigent une confirmation d'identité.",
    "gw.console.loading": "Chargement…",
    "gw.console.loadError": "Chargement impossible pour le moment.",

    "gw.console.tab.queue": "File des reversements",
    "gw.console.tab.payments": "Paiements",
    "gw.console.tab.disputes": "Litiges",
    "gw.console.tab.reconciliation": "Rapprochement",
    "gw.console.tab.trialBalance": "Balance générale",
    "gw.console.tab.commissionRules": "Règles de commission",
    "gw.console.tab.settings": "Réglages",
    "gw.console.tab.webhooks": "Webhooks en échec",

    "gw.console.payouts.colId": "Identifiant",
    "gw.console.payouts.colTenant": "Praticien",
    "gw.console.payouts.colAmount": "Montant",
    "gw.console.payouts.colRequested": "Demandé le",
    "gw.console.payouts.colOwner": "Propriétaire",
    "gw.console.payouts.leavesNow": "Montant viré",
    "gw.console.payouts.reserveHeld": "Retenu en réserve",
    "gw.console.payouts.destination": "Compte de destination",
    "gw.console.payouts.crossBorder": "Virement transfrontalier",
    "gw.console.payouts.unknownPractice": "Cabinet introuvable",
    "gw.console.payouts.empty": "Aucun reversement en attente.",
    "gw.console.payouts.approve": "Approuver",
    "gw.console.payouts.reject": "Refuser",
    "gw.console.payouts.approved": "Reversement approuvé.",
    "gw.console.payouts.rejected": "Reversement refusé.",
    "gw.console.payouts.approveTitle": "Approuver le reversement {id}",
    "gw.console.payouts.approveDesc": "Confirmez votre identité pour approuver cet envoi de fonds.",
    "gw.console.payouts.approveAck": "Je comprends que ce reversement sera approuvé.",
    "gw.console.payouts.rejectTitle": "Refuser le reversement {id}",
    "gw.console.payouts.rejectDesc": "Les ventes concernées redeviennent disponibles pour un futur reversement.",
    "gw.console.payouts.rejectReasonPlaceholder": "Motif du refus (visible en audit)",

    "gw.console.payments.hint": "Paiements de la passerelle — encaissements marketplace et téléconsultation.",
    "gw.console.payments.colId": "Identifiant",
    "gw.console.payments.colStatus": "Statut",
    "gw.console.payments.colCaptured": "Encaissé",
    "gw.console.payments.colCommission": "Commission",
    "gw.console.payments.colNet": "Net au cabinet",
    "gw.console.payments.empty": "Aucun paiement pour le moment.",
    "gw.console.payments.refund": "Rembourser",
    "gw.console.payments.refundIssued": "Remboursement émis.",
    "gw.console.payments.refundTitle": "Rembourser le paiement {id}",
    "gw.console.payments.refundDesc": "Confirmez votre identité pour émettre ce remboursement.",
    "gw.console.payments.refundAck": "Je comprends que ce remboursement sera émis.",
    "gw.console.payments.refundReasonPlaceholder": "Motif du remboursement",
    "gw.console.payments.colRefundable": "Montant remboursable",
    "gw.console.payments.colTenant": "Cabinet",
    "gw.console.payments.colReason": "Motif",
    "gw.console.payments.colItem": "Article",
    "gw.console.payments.colBuyer": "Acheteur",
    "gw.console.payments.reason.booking": "Rendez-vous",
    "gw.console.payments.reason.telehealth": "Téléconsultation",
    "gw.console.payments.reason.course": "Cours",
    "gw.console.payments.reason.pathway": "Parcours",
    "gw.console.payments.reason.program": "Programme",
    "gw.console.payments.reason.product": "Produit",
    "gw.console.payments.reason.invoice": "Facture",
    "gw.console.payments.reason.giftcard": "Carte-cadeau",
    "gw.console.payments.reason.subscription": "Abonnement",
    "gw.console.payments.reason.unknown": "Indéterminé",
    "gw.console.payments.filterTenant": "Filtrer par cabinet",
    "gw.console.payments.filterReason": "Filtrer par motif",
    "gw.console.payments.filterStatus": "Filtrer par statut",
    "gw.console.payments.filterFrom": "Du",
    "gw.console.payments.filterTo": "Au",
    "gw.console.payments.allTenants": "Tous les cabinets",
    "gw.console.payments.allReasons": "Tous les motifs",
    "gw.console.payments.allStatuses": "Tous les statuts",
    "gw.console.payments.searchPlaceholder": "Identifiant, courriel ou identifiant Stripe",
    "gw.console.payments.search": "Chercher",
    "gw.console.payments.clearFilters": "Effacer les filtres",
    "gw.console.payments.total": "{count} paiement(s)",
    "gw.console.payments.pageInfo": "{from}–{to} sur {total}",
    "gw.console.payments.prev": "Précédent",
    "gw.console.payments.next": "Suivant",
    "gw.console.payments.detail": "Détail",
    "gw.console.payments.detailTitle": "Détail du paiement",
    "gw.console.payments.detailHoldReleases": "Retenue libérée le",
    "gw.console.payments.detailCustomerPaid": "Payé par le client",
    "gw.console.payments.detailRate": "Taux de change appliqué par Stripe",
    "gw.console.payments.charged": "facturé {amount}",

    "gw.console.disputes.colId": "Identifiant",
    "gw.console.disputes.colStatus": "Statut",
    "gw.console.disputes.colRecovery": "Recouvrement",
    "gw.console.disputes.colAmount": "Montant",
    "gw.console.disputes.empty": "Aucun litige pour le moment.",
    "gw.console.disputes.recover": "Décider du recouvrement",
    "gw.console.disputes.recoveryRecorded": "Décision de recouvrement enregistrée.",
    "gw.console.disputes.recoveryTitle": "Recouvrement du litige {id}",
    "gw.console.disputes.recoveryDesc": "Confirmez votre identité pour enregistrer cette décision.",
    "gw.console.disputes.recoveryAck": "Je comprends que cette décision de recouvrement est définitive.",

    "gw.console.recon.run": "Lancer le rapprochement",
    "gw.console.recon.refresh": "Actualiser",
    "gw.console.recon.runHint": "« Actualiser » relit le rapport enregistré. « Lancer le rapprochement » le recalcule maintenant à partir des transactions Stripe de la journée.",
    "gw.console.recon.drift": "Écart détecté : {amount}",
    "gw.console.recon.noDrift": "Aucun écart — la caisse plateforme concorde avec Stripe.",
    "gw.console.recon.invariantNotChecked": "La vérification caisse plateforme n'a pas été effectuée — aucune clé Stripe utilisable. Ce n'est pas « aucun écart ».",
    "gw.console.recon.matched": "Rapprochés",
    "gw.console.recon.stripeUnmatched": "Non rapprochés (Stripe)",
    "gw.console.recon.ledgerUnmatched": "Non rapprochés (grand livre)",
    "gw.console.recon.staleRepaired": "{count} réservation(s) périmée(s) réparée(s) automatiquement.",
    "gw.console.recon.staleOrphans": "{count} réservation(s) orpheline(s) signalée(s) — aucune correction automatique : à examiner.",
    "gw.console.recon.notRun": "Aucun rapprochement pour cette date — la vérification n'a pas encore été effectuée. Ce n'est pas un résultat « conforme ».",
    "gw.console.recon.findingsClear": "Aucun constat sur le compte plateforme — vérifié.",
    "gw.console.recon.finding.settlementCurrencyMismatch": "Le compte Stripe de la plateforme ({accountId}) règle en {account} alors que la passerelle tient ses comptes en {settlement} : aucun frais Stripe ne peut être comptabilisé et l'écart de caisse ci-dessus vaut la recette du jour tant que les deux ne concordent pas.",
    "gw.console.recon.finding.payoutScheduleAutomatic": "Les virements automatiques du compte plateforme sont activés ({interval}) : ils vident le solde sur lequel les reversements sont prélevés. À passer en manuel avant la mise en production.",
    "gw.console.recon.finding.solvencyBreach": "Solvabilité : {owed} dus aux praticiens pour {available} disponibles sur Stripe.",
    "gw.console.recon.finding.solvencySkipped": "La vérification de solvabilité n'a pas été effectuée — Stripe n'a pas été consulté. Ce n'est pas « solvable ».",

    "gw.console.commission.newRule": "Nouvelle règle de commission",
    "gw.console.commission.scope": "Portée",
    "gw.console.commission.tenantId": "Identifiant du cabinet",
    "gw.console.commission.productType": "Type de produit",
    "gw.console.commission.rateBps": "Taux (points de base)",
    "gw.console.commission.save": "Enregistrer la règle",
    "gw.console.commission.saved": "Règle de commission enregistrée.",
    "gw.console.commission.empty": "Aucune règle de commission configurée.",
    "gw.console.commission.deletedPractice": "{name} (cabinet supprimé)",

    "gw.console.settings.title": "Réglages de la passerelle",
    "gw.console.settings.defaultCommissionBps": "Commission par défaut (points de base)",
    "gw.console.settings.holdDays": "Durée de rétention (jours)",
    "gw.console.settings.minPayoutCents": "Retrait minimum (centimes)",
    "gw.console.settings.autoApproveMaxCents": "Plafond d'auto-approbation (centimes)",
    "gw.console.settings.rollingReservePct": "Réserve tournante (%)",
    "gw.console.settings.rollingReserveDays": "Durée de la réserve tournante (jours)",
    "gw.console.settings.noShowFeeCents": "Frais d'absence (centimes)",
    "gw.console.settings.rescheduleMinNoticeHours": "Préavis minimum de report (heures)",
    "gw.console.settings.noCeiling": "aucun plafond",
    "gw.console.settings.minRatePerMinuteCents": "Tarif minimum par minute (centimes)",
    "gw.console.settings.maxRatePerMinuteCents": "Tarif maximum par minute (centimes)",
    "gw.console.settings.feesAbsorbedByPlatform": "Frais Stripe absorbés par la plateforme",
    "gw.console.settings.legacyPayoutsDisabled": "Ancien système de reversement désactivé",
    "gw.console.settings.save": "Enregistrer les réglages",
    "gw.console.settings.saved": "Réglages enregistrés.",
    "gw.console.settings.confirmTitle": "Enregistrer les réglages de la passerelle",
    "gw.console.settings.confirmDesc": "Confirmez votre identité pour appliquer ces réglages à toute la plateforme.",
    "gw.console.settings.confirmAck": "Je comprends que ces réglages s'appliqueront immédiatement.",

    "gw.console.webhooks.hint": "Événements Stripe qui ont épuisé leurs tentatives de traitement.",
    "gw.console.webhooks.colEvent": "Événement",
    "gw.console.webhooks.colStatus": "Statut",
    "gw.console.webhooks.colAttempts": "Tentatives",
    "gw.console.webhooks.colReceived": "Reçu le",
    "gw.console.webhooks.colProcessed": "Traité le",
    "gw.console.webhooks.colLastError": "Dernière erreur",
    "gw.console.webhooks.empty": "Aucun webhook en échec.",

    "gw.console.trialBalance.title": "Balance générale",
    "gw.console.trialBalance.refresh": "Actualiser",
    "gw.console.trialBalance.unbalanced": "Le grand livre ne s'équilibre pas — écart de {amount}, investigation requise.",
    "gw.console.trialBalance.balanced": "Le grand livre s'équilibre à zéro.",
    "gw.console.trialBalance.colAccount": "Compte",
    "gw.console.trialBalance.colBalance": "Solde",
    "gw.console.trialBalance.debitNormal": "Débit",
    "gw.console.trialBalance.creditNormal": "Crédit",
    "gw.console.trialBalance.normalBalanceHint": "Sens naturel du compte (débit ou crédit) — n'affecte pas l'affichage du solde, qui est déjà à signe corrigé.",

    "gw.console.account.platform_cash": "Caisse plateforme",
    "gw.console.account.tenant_payable": "Dû aux cabinets",
    "gw.console.account.platform_revenue_commission": "Revenu de commission",
    "gw.console.account.platform_revenue_subscription": "Revenu d'abonnement",
    "gw.console.account.stripe_fees": "Frais Stripe",
    "gw.console.account.refunds_payable": "Remboursements à verser",
    "gw.console.account.dispute_losses": "Pertes sur litiges",
    "gw.console.account.tenant_adjustments": "Ajustements des cabinets",
    "gw.console.account.platform_adjustment_expense": "Coût des gestes commerciaux",
    "gw.console.account.platform_equity_opening": "Capitaux propres d'ouverture",
    "gw.console.account.giftcard_liability": "Cartes-cadeaux non utilisées",
    "gw.console.account.affiliate_payable": "Dû aux affiliés",
    "gw.console.account.platform_affiliate_expense": "Coût du programme d'affiliation",
    "gw.console.account.unknown": "Compte inconnu",

    "gw.console.dlg.back": "Retour",
    "gw.console.dlg.continue": "Continuer",
    "gw.console.dlg.reasonTooShort": "Le motif doit compter au moins {min} caractères.",
    "gw.console.dlg.genericAck": "Je confirme cette action.",

    "gw.scope.platform": "Plateforme",
    "gw.scope.tenant": "Cabinet",
    "gw.productType.all": "Tous les types de produit",
    "gw.productType.telehealth": "Téléconsultation",
    "gw.productType.digital": "Numérique",
    "gw.productType.physical": "Physique",
    "gw.productType.in_person": "En personne",

    "gw.state.awaiting_payment_method": "En attente d'un moyen de paiement",
    "gw.state.awaiting_authorisation": "En attente d'autorisation",
    "gw.state.card_saved": "Carte enregistrée",
    "gw.state.authorising": "Autorisation en cours",
    "gw.state.auth_failed": "Autorisation échouée",
    "gw.state.requires_capture": "Autorisé, à encaisser",
    "gw.state.capturing": "Encaissement en cours",
    "gw.state.captured": "Encaissé",
    "gw.state.partially_captured": "Partiellement encaissé",
    "gw.state.settled": "Réglé",
    "gw.state.cancelling": "Annulation en cours",
    "gw.state.cancelled": "Annulé",
    "gw.state.expired": "Expiré",
    "gw.state.failed": "Échoué",
    "gw.state.refunded": "Remboursé",
    "gw.state.partially_refunded": "Partiellement remboursé",
    "gw.state.disputed": "Contesté",
    "gw.state.needs_response": "Réponse requise",
    "gw.state.under_review": "En cours d'examen",
    "gw.state.won": "Gagné",
    "gw.state.lost": "Perdu",
    "gw.state.pending": "En attente",
    "gw.state.netted": "Compensé",
    "gw.state.reversed": "Annulé (renversé)",
    "gw.state.absorbed": "Absorbé par la plateforme",
    "gw.state.unknown": "Statut inconnu",
    // A refund's own lifecycle (modules/gateway/refunds.py): `authorised` until Stripe answers,
    // then `settled` or `failed`. Not the payment vocabulary above.
    "gw.state.refund.authorised": "Remboursement en cours",
    "gw.state.refund.settled": "Remboursé",
    "gw.state.refund.failed": "Remboursement échoué",
  },
  en: {
    "nav.gateway": "Payment gateway",

    "gw.console.title": "Payment gateway",
    "gw.console.subtitle": "Payouts, payments, disputes and the ledger behind the payment system — actions that move money require an identity confirmation.",
    "gw.console.loading": "Loading…",
    "gw.console.loadError": "Could not load this right now.",

    "gw.console.tab.queue": "Payout queue",
    "gw.console.tab.payments": "Payments",
    "gw.console.tab.disputes": "Disputes",
    "gw.console.tab.reconciliation": "Reconciliation",
    "gw.console.tab.trialBalance": "Trial balance",
    "gw.console.tab.commissionRules": "Commission rules",
    "gw.console.tab.settings": "Settings",
    "gw.console.tab.webhooks": "Dead-letter webhooks",

    "gw.console.payouts.colId": "ID",
    "gw.console.payouts.colTenant": "Practitioner",
    "gw.console.payouts.colAmount": "Amount",
    "gw.console.payouts.colRequested": "Requested",
    "gw.console.payouts.colOwner": "Owner",
    "gw.console.payouts.leavesNow": "Amount transferred",
    "gw.console.payouts.reserveHeld": "Held in reserve",
    "gw.console.payouts.destination": "Destination account",
    "gw.console.payouts.crossBorder": "Cross-border transfer",
    "gw.console.payouts.unknownPractice": "Practice not found",
    "gw.console.payouts.empty": "No payouts awaiting approval.",
    "gw.console.payouts.approve": "Approve",
    "gw.console.payouts.reject": "Reject",
    "gw.console.payouts.approved": "Payout approved.",
    "gw.console.payouts.rejected": "Payout rejected.",
    "gw.console.payouts.approveTitle": "Approve payout {id}",
    "gw.console.payouts.approveDesc": "Confirm your identity to approve this transfer.",
    "gw.console.payouts.approveAck": "I understand this payout will be approved.",
    "gw.console.payouts.rejectTitle": "Reject payout {id}",
    "gw.console.payouts.rejectDesc": "The underlying sales become available for a future payout again.",
    "gw.console.payouts.rejectReasonPlaceholder": "Reason for rejection (kept for audit)",

    "gw.console.payments.hint": "Gateway payments — marketplace and telehealth collections.",
    "gw.console.payments.colId": "ID",
    "gw.console.payments.colStatus": "Status",
    "gw.console.payments.colCaptured": "Captured",
    "gw.console.payments.colCommission": "Commission",
    "gw.console.payments.colNet": "Net to practice",
    "gw.console.payments.empty": "No payments yet.",
    "gw.console.payments.refund": "Refund",
    "gw.console.payments.refundIssued": "Refund issued.",
    "gw.console.payments.refundTitle": "Refund payment {id}",
    "gw.console.payments.refundDesc": "Confirm your identity to issue this refund.",
    "gw.console.payments.refundAck": "I understand this refund will be issued.",
    "gw.console.payments.refundReasonPlaceholder": "Reason for the refund",
    "gw.console.payments.colRefundable": "Refundable amount",
    "gw.console.payments.colTenant": "Practice",
    "gw.console.payments.colReason": "Reason",
    "gw.console.payments.colItem": "Item",
    "gw.console.payments.colBuyer": "Buyer",
    "gw.console.payments.reason.booking": "Appointment",
    "gw.console.payments.reason.telehealth": "Telehealth",
    "gw.console.payments.reason.course": "Course",
    "gw.console.payments.reason.pathway": "Pathway",
    "gw.console.payments.reason.program": "Program",
    "gw.console.payments.reason.product": "Product",
    "gw.console.payments.reason.invoice": "Invoice",
    "gw.console.payments.reason.giftcard": "Gift card",
    "gw.console.payments.reason.subscription": "Subscription",
    "gw.console.payments.reason.unknown": "Unidentified",
    "gw.console.payments.filterTenant": "Filter by practice",
    "gw.console.payments.filterReason": "Filter by reason",
    "gw.console.payments.filterStatus": "Filter by status",
    "gw.console.payments.filterFrom": "From",
    "gw.console.payments.filterTo": "To",
    "gw.console.payments.allTenants": "All practices",
    "gw.console.payments.allReasons": "All reasons",
    "gw.console.payments.allStatuses": "All statuses",
    "gw.console.payments.searchPlaceholder": "Payment id, email or Stripe id",
    "gw.console.payments.search": "Search",
    "gw.console.payments.clearFilters": "Clear filters",
    "gw.console.payments.total": "{count} payment(s)",
    "gw.console.payments.pageInfo": "{from}–{to} of {total}",
    "gw.console.payments.prev": "Previous",
    "gw.console.payments.next": "Next",
    "gw.console.payments.detail": "Details",
    "gw.console.payments.detailTitle": "Payment details",
    "gw.console.payments.detailHoldReleases": "Hold releases on",
    "gw.console.payments.detailCustomerPaid": "Customer paid",
    "gw.console.payments.detailRate": "Stripe exchange rate",
    "gw.console.payments.charged": "charged {amount}",

    "gw.console.disputes.colId": "ID",
    "gw.console.disputes.colStatus": "Status",
    "gw.console.disputes.colRecovery": "Recovery",
    "gw.console.disputes.colAmount": "Amount",
    "gw.console.disputes.empty": "No disputes yet.",
    "gw.console.disputes.recover": "Decide recovery",
    "gw.console.disputes.recoveryRecorded": "Recovery decision recorded.",
    "gw.console.disputes.recoveryTitle": "Recovery for dispute {id}",
    "gw.console.disputes.recoveryDesc": "Confirm your identity to record this decision.",
    "gw.console.disputes.recoveryAck": "I understand this recovery decision is final.",

    "gw.console.recon.run": "Run reconciliation",
    "gw.console.recon.refresh": "Refresh",
    "gw.console.recon.runHint": "“Refresh” re-reads the stored report. “Run reconciliation” recomputes it now from that day's Stripe balance transactions.",
    "gw.console.recon.drift": "Drift detected: {amount}",
    "gw.console.recon.noDrift": "No drift — the platform cash account matches Stripe.",
    "gw.console.recon.invariantNotChecked": "The platform-cash check did not run — no usable Stripe key. This is not \"no drift\".",
    "gw.console.recon.matched": "Matched",
    "gw.console.recon.stripeUnmatched": "Unmatched (Stripe)",
    "gw.console.recon.ledgerUnmatched": "Unmatched (ledger)",
    "gw.console.recon.staleRepaired": "{count} stale reservation(s) auto-repaired.",
    "gw.console.recon.staleOrphans": "{count} orphaned reservation(s) reported — not auto-corrected, needs a look.",
    "gw.console.recon.notRun": "No reconciliation for this date — the check has not run yet. This is not a clean result.",
    "gw.console.recon.findingsClear": "No findings on the platform account — checked.",
    "gw.console.recon.finding.settlementCurrencyMismatch": "The platform's Stripe account ({accountId}) settles in {account} while the gateway keeps its books in {settlement}: no Stripe fee can be booked, and the cash drift above equals the day's takings until the two agree.",
    "gw.console.recon.finding.payoutScheduleAutomatic": "Automatic payouts from the platform account are on ({interval}): they drain the balance that payout transfers draw from. Switch to manual before going live.",
    "gw.console.recon.finding.solvencyBreach": "Solvency: {owed} owed to practitioners against {available} available on Stripe.",
    "gw.console.recon.finding.solvencySkipped": "The solvency check did not run — Stripe was not consulted. This is not \"solvent\".",

    "gw.console.commission.newRule": "New commission rule",
    "gw.console.commission.scope": "Scope",
    "gw.console.commission.tenantId": "Tenant ID",
    "gw.console.commission.productType": "Product type",
    "gw.console.commission.rateBps": "Rate (basis points)",
    "gw.console.commission.save": "Save rule",
    "gw.console.commission.saved": "Commission rule saved.",
    "gw.console.commission.empty": "No commission rules configured.",
    "gw.console.commission.deletedPractice": "{name} (practice deleted)",

    "gw.console.settings.title": "Gateway settings",
    "gw.console.settings.defaultCommissionBps": "Default commission (basis points)",
    "gw.console.settings.holdDays": "Hold duration (days)",
    "gw.console.settings.minPayoutCents": "Minimum payout (cents)",
    "gw.console.settings.autoApproveMaxCents": "Auto-approve ceiling (cents)",
    "gw.console.settings.rollingReservePct": "Rolling reserve (%)",
    "gw.console.settings.rollingReserveDays": "Rolling reserve duration (days)",
    "gw.console.settings.noShowFeeCents": "No-show fee (cents)",
    "gw.console.settings.rescheduleMinNoticeHours": "Reschedule minimum notice (hours)",
    "gw.console.settings.noCeiling": "no ceiling",
    "gw.console.settings.minRatePerMinuteCents": "Minimum rate per minute (cents)",
    "gw.console.settings.maxRatePerMinuteCents": "Maximum rate per minute (cents)",
    "gw.console.settings.feesAbsorbedByPlatform": "Stripe fees absorbed by the platform",
    "gw.console.settings.legacyPayoutsDisabled": "Legacy payout system disabled",
    "gw.console.settings.save": "Save settings",
    "gw.console.settings.saved": "Settings saved.",
    "gw.console.settings.confirmTitle": "Save gateway settings",
    "gw.console.settings.confirmDesc": "Confirm your identity to apply these settings platform-wide.",
    "gw.console.settings.confirmAck": "I understand these settings will apply immediately.",

    "gw.console.webhooks.hint": "Stripe events that exhausted their processing attempts.",
    "gw.console.webhooks.colEvent": "Event",
    "gw.console.webhooks.colStatus": "Status",
    "gw.console.webhooks.colAttempts": "Attempts",
    "gw.console.webhooks.colReceived": "Received",
    "gw.console.webhooks.colProcessed": "Processed",
    "gw.console.webhooks.colLastError": "Last error",
    "gw.console.webhooks.empty": "No dead-letter webhooks.",

    "gw.console.trialBalance.title": "Trial balance",
    "gw.console.trialBalance.refresh": "Refresh",
    "gw.console.trialBalance.unbalanced": "The ledger does not balance — drift of {amount}, investigation required.",
    "gw.console.trialBalance.balanced": "The ledger balances to zero.",
    "gw.console.trialBalance.colAccount": "Account",
    "gw.console.trialBalance.colBalance": "Balance",
    "gw.console.trialBalance.debitNormal": "Debit",
    "gw.console.trialBalance.creditNormal": "Credit",
    "gw.console.trialBalance.normalBalanceHint": "The account's natural side (debit or credit) — does not affect the balance shown, which is already sign-corrected.",

    "gw.console.account.platform_cash": "Platform cash",
    "gw.console.account.tenant_payable": "Owed to tenants",
    "gw.console.account.platform_revenue_commission": "Commission revenue",
    "gw.console.account.platform_revenue_subscription": "Subscription revenue",
    "gw.console.account.stripe_fees": "Stripe fees",
    "gw.console.account.refunds_payable": "Refunds payable",
    "gw.console.account.dispute_losses": "Dispute losses",
    "gw.console.account.tenant_adjustments": "Tenant adjustments",
    "gw.console.account.platform_adjustment_expense": "Operator credit expense",
    "gw.console.account.platform_equity_opening": "Opening platform equity",
    "gw.console.account.giftcard_liability": "Unredeemed gift cards",
    "gw.console.account.affiliate_payable": "Owed to affiliates",
    "gw.console.account.platform_affiliate_expense": "Affiliate program cost",
    "gw.console.account.unknown": "Unknown account",

    "gw.console.dlg.back": "Back",
    "gw.console.dlg.continue": "Continue",
    "gw.console.dlg.reasonTooShort": "The reason must be at least {min} characters.",
    "gw.console.dlg.genericAck": "I confirm this action.",

    "gw.scope.platform": "Platform",
    "gw.scope.tenant": "Tenant",
    "gw.productType.all": "All product types",
    "gw.productType.telehealth": "Telehealth consultation",
    "gw.productType.digital": "Digital",
    "gw.productType.physical": "Physical",
    "gw.productType.in_person": "In person",

    "gw.state.awaiting_payment_method": "Awaiting payment method",
    "gw.state.awaiting_authorisation": "Awaiting authorisation",
    "gw.state.card_saved": "Card saved",
    "gw.state.authorising": "Authorising",
    "gw.state.auth_failed": "Authorisation failed",
    "gw.state.requires_capture": "Authorised, awaiting capture",
    "gw.state.capturing": "Capturing",
    "gw.state.captured": "Captured",
    "gw.state.partially_captured": "Partially captured",
    "gw.state.settled": "Settled",
    "gw.state.cancelling": "Cancelling",
    "gw.state.cancelled": "Cancelled",
    "gw.state.expired": "Expired",
    "gw.state.failed": "Failed",
    "gw.state.refunded": "Refunded",
    "gw.state.partially_refunded": "Partially refunded",
    "gw.state.disputed": "Disputed",
    "gw.state.needs_response": "Needs response",
    "gw.state.under_review": "Under review",
    "gw.state.won": "Won",
    "gw.state.lost": "Lost",
    "gw.state.pending": "Pending",
    "gw.state.netted": "Netted",
    "gw.state.reversed": "Reversed",
    "gw.state.absorbed": "Absorbed by the platform",
    "gw.state.unknown": "Unknown status",
    "gw.state.refund.authorised": "Refund pending",
    "gw.state.refund.settled": "Refunded",
    "gw.state.refund.failed": "Refund failed",
  },
  es: {
    "nav.gateway": "Pasarela de pago",

    "gw.console.title": "Pasarela de pago",
    "gw.console.subtitle": "Reversos, pagos, disputas y el libro contable del sistema de pagos — las acciones que mueven dinero requieren confirmar la identidad.",
    "gw.console.loading": "Cargando…",
    "gw.console.loadError": "No se pudo cargar en este momento.",

    "gw.console.tab.queue": "Cola de reversos",
    "gw.console.tab.payments": "Pagos",
    "gw.console.tab.disputes": "Disputas",
    "gw.console.tab.reconciliation": "Conciliación",
    "gw.console.tab.trialBalance": "Balance de comprobación",
    "gw.console.tab.commissionRules": "Reglas de comisión",
    "gw.console.tab.settings": "Configuración",
    "gw.console.tab.webhooks": "Webhooks fallidos",

    "gw.console.payouts.colId": "ID",
    "gw.console.payouts.colTenant": "Profesional",
    "gw.console.payouts.colAmount": "Monto",
    "gw.console.payouts.colRequested": "Solicitado",
    "gw.console.payouts.colOwner": "Propietario",
    "gw.console.payouts.leavesNow": "Importe transferido",
    "gw.console.payouts.reserveHeld": "Retenido en reserva",
    "gw.console.payouts.destination": "Cuenta de destino",
    "gw.console.payouts.crossBorder": "Transferencia transfronteriza",
    "gw.console.payouts.unknownPractice": "Consulta no encontrada",
    "gw.console.payouts.empty": "No hay reversos pendientes de aprobación.",
    "gw.console.payouts.approve": "Aprobar",
    "gw.console.payouts.reject": "Rechazar",
    "gw.console.payouts.approved": "Reverso aprobado.",
    "gw.console.payouts.rejected": "Reverso rechazado.",
    "gw.console.payouts.approveTitle": "Aprobar reverso {id}",
    "gw.console.payouts.approveDesc": "Confirme su identidad para aprobar esta transferencia.",
    "gw.console.payouts.approveAck": "Entiendo que este reverso será aprobado.",
    "gw.console.payouts.rejectTitle": "Rechazar reverso {id}",
    "gw.console.payouts.rejectDesc": "Las ventas correspondientes vuelven a estar disponibles para un futuro reverso.",
    "gw.console.payouts.rejectReasonPlaceholder": "Motivo del rechazo (queda registrado)",

    "gw.console.payments.hint": "Pagos de la pasarela — cobros de marketplace y teleconsulta.",
    "gw.console.payments.colId": "ID",
    "gw.console.payments.colStatus": "Estado",
    "gw.console.payments.colCaptured": "Cobrado",
    "gw.console.payments.colCommission": "Comisión",
    "gw.console.payments.colNet": "Neto para la consulta",
    "gw.console.payments.empty": "Aún no hay pagos.",
    "gw.console.payments.refund": "Reembolsar",
    "gw.console.payments.refundIssued": "Reembolso emitido.",
    "gw.console.payments.refundTitle": "Reembolsar el pago {id}",
    "gw.console.payments.refundDesc": "Confirme su identidad para emitir este reembolso.",
    "gw.console.payments.refundAck": "Entiendo que este reembolso será emitido.",
    "gw.console.payments.refundReasonPlaceholder": "Motivo del reembolso",
    "gw.console.payments.colRefundable": "Monto reembolsable",
    "gw.console.payments.colTenant": "Consulta",
    "gw.console.payments.colReason": "Motivo",
    "gw.console.payments.colItem": "Artículo",
    "gw.console.payments.colBuyer": "Comprador",
    "gw.console.payments.reason.booking": "Cita",
    "gw.console.payments.reason.telehealth": "Teleconsulta",
    "gw.console.payments.reason.course": "Curso",
    "gw.console.payments.reason.pathway": "Itinerario",
    "gw.console.payments.reason.program": "Programa",
    "gw.console.payments.reason.product": "Producto",
    "gw.console.payments.reason.invoice": "Factura",
    "gw.console.payments.reason.giftcard": "Tarjeta regalo",
    "gw.console.payments.reason.subscription": "Suscripción",
    "gw.console.payments.reason.unknown": "Sin identificar",
    "gw.console.payments.filterTenant": "Filtrar por consulta",
    "gw.console.payments.filterReason": "Filtrar por motivo",
    "gw.console.payments.filterStatus": "Filtrar por estado",
    "gw.console.payments.filterFrom": "Desde",
    "gw.console.payments.filterTo": "Hasta",
    "gw.console.payments.allTenants": "Todas las consultas",
    "gw.console.payments.allReasons": "Todos los motivos",
    "gw.console.payments.allStatuses": "Todos los estados",
    "gw.console.payments.searchPlaceholder": "Id de pago, correo o id de Stripe",
    "gw.console.payments.search": "Buscar",
    "gw.console.payments.clearFilters": "Borrar filtros",
    "gw.console.payments.total": "{count} pago(s)",
    "gw.console.payments.pageInfo": "{from}–{to} de {total}",
    "gw.console.payments.prev": "Anterior",
    "gw.console.payments.next": "Siguiente",
    "gw.console.payments.detail": "Detalle",
    "gw.console.payments.detailTitle": "Detalle del pago",
    "gw.console.payments.detailHoldReleases": "Retención liberada el",
    "gw.console.payments.detailCustomerPaid": "Pagado por el cliente",
    "gw.console.payments.detailRate": "Tipo de cambio de Stripe",
    "gw.console.payments.charged": "cobrado {amount}",

    "gw.console.disputes.colId": "ID",
    "gw.console.disputes.colStatus": "Estado",
    "gw.console.disputes.colRecovery": "Recuperación",
    "gw.console.disputes.colAmount": "Monto",
    "gw.console.disputes.empty": "Aún no hay disputas.",
    "gw.console.disputes.recover": "Decidir recuperación",
    "gw.console.disputes.recoveryRecorded": "Decisión de recuperación registrada.",
    "gw.console.disputes.recoveryTitle": "Recuperación de la disputa {id}",
    "gw.console.disputes.recoveryDesc": "Confirme su identidad para registrar esta decisión.",
    "gw.console.disputes.recoveryAck": "Entiendo que esta decisión de recuperación es definitiva.",

    "gw.console.recon.run": "Ejecutar conciliación",
    "gw.console.recon.refresh": "Actualizar",
    "gw.console.recon.runHint": "«Actualizar» vuelve a leer el informe guardado. «Ejecutar conciliación» lo recalcula ahora a partir de las transacciones de Stripe del día.",
    "gw.console.recon.drift": "Desviación detectada: {amount}",
    "gw.console.recon.noDrift": "Sin desviación — la caja de la plataforma coincide con Stripe.",
    "gw.console.recon.invariantNotChecked": "La verificación de caja de la plataforma no se ejecutó — no hay clave de Stripe utilizable. Esto no es \"sin desviación\".",
    "gw.console.recon.matched": "Conciliados",
    "gw.console.recon.stripeUnmatched": "Sin conciliar (Stripe)",
    "gw.console.recon.ledgerUnmatched": "Sin conciliar (libro contable)",
    "gw.console.recon.staleRepaired": "{count} reserva(s) obsoleta(s) reparada(s) automáticamente.",
    "gw.console.recon.staleOrphans": "{count} reserva(s) huérfana(s) señalada(s) — sin corrección automática: requiere revisión.",
    "gw.console.recon.notRun": "No hay conciliación para esta fecha — la comprobación aún no se ha ejecutado. Esto no es un resultado «conforme».",
    "gw.console.recon.findingsClear": "Sin hallazgos en la cuenta de la plataforma — verificado.",
    "gw.console.recon.finding.settlementCurrencyMismatch": "La cuenta Stripe de la plataforma ({accountId}) liquida en {account} mientras la pasarela lleva sus libros en {settlement}: no se puede contabilizar ninguna comisión de Stripe y la desviación de caja anterior equivale a la recaudación del día hasta que ambas coincidan.",
    "gw.console.recon.finding.payoutScheduleAutomatic": "Los pagos automáticos de la cuenta de la plataforma están activados ({interval}): vacían el saldo del que se extraen las transferencias. Cambia a manual antes de salir a producción.",
    "gw.console.recon.finding.solvencyBreach": "Solvencia: {owed} adeudados a los profesionales frente a {available} disponibles en Stripe.",
    "gw.console.recon.finding.solvencySkipped": "La verificación de solvencia no se realizó — no se consultó a Stripe. Esto no es « solvente ».",

    "gw.console.commission.newRule": "Nueva regla de comisión",
    "gw.console.commission.scope": "Alcance",
    "gw.console.commission.tenantId": "ID de la consulta",
    "gw.console.commission.productType": "Tipo de producto",
    "gw.console.commission.rateBps": "Tasa (puntos básicos)",
    "gw.console.commission.save": "Guardar regla",
    "gw.console.commission.saved": "Regla de comisión guardada.",
    "gw.console.commission.empty": "No hay reglas de comisión configuradas.",
    "gw.console.commission.deletedPractice": "{name} (consulta eliminada)",

    "gw.console.settings.title": "Configuración de la pasarela",
    "gw.console.settings.defaultCommissionBps": "Comisión predeterminada (puntos básicos)",
    "gw.console.settings.holdDays": "Duración de retención (días)",
    "gw.console.settings.minPayoutCents": "Retiro mínimo (centavos)",
    "gw.console.settings.autoApproveMaxCents": "Límite de auto-aprobación (centavos)",
    "gw.console.settings.rollingReservePct": "Reserva rotativa (%)",
    "gw.console.settings.rollingReserveDays": "Duración de la reserva rotativa (días)",
    "gw.console.settings.noShowFeeCents": "Tarifa por ausencia (céntimos)",
    "gw.console.settings.rescheduleMinNoticeHours": "Aviso mínimo para reprogramar (horas)",
    "gw.console.settings.noCeiling": "sin límite",
    "gw.console.settings.minRatePerMinuteCents": "Tarifa mínima por minuto (centavos)",
    "gw.console.settings.maxRatePerMinuteCents": "Tarifa máxima por minuto (centavos)",
    "gw.console.settings.feesAbsorbedByPlatform": "Comisiones de Stripe absorbidas por la plataforma",
    "gw.console.settings.legacyPayoutsDisabled": "Sistema de reversos antiguo desactivado",
    "gw.console.settings.save": "Guardar configuración",
    "gw.console.settings.saved": "Configuración guardada.",
    "gw.console.settings.confirmTitle": "Guardar la configuración de la pasarela",
    "gw.console.settings.confirmDesc": "Confirme su identidad para aplicar esta configuración a toda la plataforma.",
    "gw.console.settings.confirmAck": "Entiendo que esta configuración se aplicará de inmediato.",

    "gw.console.webhooks.hint": "Eventos de Stripe que agotaron sus intentos de procesamiento.",
    "gw.console.webhooks.colEvent": "Evento",
    "gw.console.webhooks.colStatus": "Estado",
    "gw.console.webhooks.colAttempts": "Intentos",
    "gw.console.webhooks.colReceived": "Recibido el",
    "gw.console.webhooks.colProcessed": "Procesado el",
    "gw.console.webhooks.colLastError": "Último error",
    "gw.console.webhooks.empty": "No hay webhooks fallidos.",

    "gw.console.trialBalance.title": "Balance de comprobación",
    "gw.console.trialBalance.refresh": "Actualizar",
    "gw.console.trialBalance.unbalanced": "El libro contable no está equilibrado — desviación de {amount}, se requiere investigación.",
    "gw.console.trialBalance.balanced": "El libro contable está equilibrado en cero.",
    "gw.console.trialBalance.colAccount": "Cuenta",
    "gw.console.trialBalance.colBalance": "Saldo",
    "gw.console.trialBalance.debitNormal": "Débito",
    "gw.console.trialBalance.creditNormal": "Crédito",
    "gw.console.trialBalance.normalBalanceHint": "Lado natural de la cuenta (débito o crédito) — no afecta el saldo mostrado, que ya está con el signo corregido.",

    "gw.console.account.platform_cash": "Caja de la plataforma",
    "gw.console.account.tenant_payable": "Adeudado a las consultas",
    "gw.console.account.platform_revenue_commission": "Ingresos por comisión",
    "gw.console.account.platform_revenue_subscription": "Ingresos por suscripción",
    "gw.console.account.stripe_fees": "Comisiones de Stripe",
    "gw.console.account.refunds_payable": "Reembolsos por pagar",
    "gw.console.account.dispute_losses": "Pérdidas por disputas",
    "gw.console.account.tenant_adjustments": "Ajustes de consultas",
    "gw.console.account.platform_adjustment_expense": "Coste de créditos de operador",
    "gw.console.account.platform_equity_opening": "Capital de apertura de la plataforma",
    "gw.console.account.giftcard_liability": "Tarjetas regalo sin canjear",
    "gw.console.account.affiliate_payable": "Adeudado a los afiliados",
    "gw.console.account.platform_affiliate_expense": "Coste del programa de afiliados",
    "gw.console.account.unknown": "Cuenta desconocida",

    "gw.console.dlg.back": "Volver",
    "gw.console.dlg.continue": "Continuar",
    "gw.console.dlg.reasonTooShort": "El motivo debe tener al menos {min} caracteres.",
    "gw.console.dlg.genericAck": "Confirmo esta acción.",

    "gw.scope.platform": "Plataforma",
    "gw.scope.tenant": "Consulta",
    "gw.productType.all": "Todos los tipos de producto",
    "gw.productType.telehealth": "Teleconsulta",
    "gw.productType.digital": "Digital",
    "gw.productType.physical": "Físico",
    "gw.productType.in_person": "En persona",

    "gw.state.awaiting_payment_method": "Esperando método de pago",
    "gw.state.awaiting_authorisation": "Esperando autorización",
    "gw.state.card_saved": "Tarjeta guardada",
    "gw.state.authorising": "Autorizando",
    "gw.state.auth_failed": "Autorización fallida",
    "gw.state.requires_capture": "Autorizado, pendiente de cobro",
    "gw.state.capturing": "Cobrando",
    "gw.state.captured": "Cobrado",
    "gw.state.partially_captured": "Parcialmente cobrado",
    "gw.state.settled": "Liquidado",
    "gw.state.cancelling": "Cancelando",
    "gw.state.cancelled": "Cancelado",
    "gw.state.expired": "Expirado",
    "gw.state.failed": "Fallido",
    "gw.state.refunded": "Reembolsado",
    "gw.state.partially_refunded": "Parcialmente reembolsado",
    "gw.state.disputed": "En disputa",
    "gw.state.needs_response": "Requiere respuesta",
    "gw.state.under_review": "En revisión",
    "gw.state.won": "Ganada",
    "gw.state.lost": "Perdida",
    "gw.state.pending": "Pendiente",
    "gw.state.netted": "Compensado",
    "gw.state.reversed": "Revertido",
    "gw.state.absorbed": "Absorbido por la plataforma",
    "gw.state.unknown": "Estado desconocido",
    "gw.state.refund.authorised": "Reembolso en curso",
    "gw.state.refund.settled": "Reembolsado",
    "gw.state.refund.failed": "Reembolso fallido",
  },
};
